<template>
  <div
    :id="componentId"
    v-product-impression="{ impression: 'impression' }"
    class="whats-inside-block"
  >
    <div v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }">
      <h1
        v-if="productData.title.includes('</')"
        class="block-title"
        v-html="productData.title"
      ></h1>
      <h1 v-else class="block-title">{{ productData.title }}</h1>
    </div>

    <slot name="main-desc"></slot>
    <img
      v-if="productData.image"
      v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
      class="main-block-image"
      :src="productData.image.Src"
      :alt="productData.image.Alt"
    />
    <div
      v-for="(product, index) in ingrediantsList"
      :key="'product' + index"
      class="title-image-block"
    >
      <div :class="imageBlockStyles('center')">
        <div v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }">
          <h2
            v-if="product.title.includes('</')"
            class="half-image-title"
            :class="halfImageTitleStyle('center')"
            v-html="product.title"
          ></h2>
          <h2 v-else class="half-image-title" :class="halfImageTitleStyle('center')">
            {{ product.title }}
          </h2>
        </div>

        <div v-if="product.subtitle" v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }">
          <h3
            v-if="product.subtitle.includes('</')"
            class="product-subtitle-data"
            v-html="product.subtitle"
          ></h3>
          <h3 v-else class="product-subtitle-data">{{ product.subtitle }}</h3>
        </div>

        <div
          v-if="product.isTextDescription"
          class="main-block-description"
          :style="'background-color:' + product.textDescriptionBgHEXCode + ';'"
          v-html="product.textDescription"
        ></div>
        <img
          v-if="product.image"
          v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
          class="main-block-image"
          :src="product.image.Src"
          :alt="product.image.Alt"
        />
        <div
          v-if="product.description"
          v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
          :class="descriptionOverlapStyle(product)"
        >
          <quote-box v-if="product.isdescription_Quote" :content="product.description"></quote-box>
          <slot v-else :name="product.blockId"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteBox from './quote-box.vue';
export default {
  name: 'whats-inside',
  components: {
    QuoteBox,
  },
  props: {
    initialdata: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'whats-inside',
    };
  },
  computed: {
    productData() {
      return JSON.parse(this.initialdata);
    },
    // set maximum items to visible in ui
    ingrediantsList() {
      const list = this.productData.whats_Inside_Block;
      const max = this.productData.maximumImages;
      if (list.length > max) {
        return list.slice(0, max);
      } else {
        return list;
      }
    },
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
    descriptionOverlapStyle(product) {
      const descStyle = product.descriptionNotOverlap
        ? 'desc-block-non-overlap'
        : 'desc-block-overlap';
      const bgStyle = product.isBg_Description_White ? 'desc-white-bg' : 'desc-grey-bg';
      return `${bgStyle}  ${descStyle}`;
    },
    imageBlockStyles(alignment) {
      if (alignment === 'center') {
        return 'img-title-block-center';
      } else if (alignment === 'left') {
        return 'img-title-block-left';
      } else {
        return 'img-title-block-right';
      }
    },
    halfImageTitleStyle(alignment) {
      if (alignment === 'left') {
        return 'img-title-left';
      } else if (alignment === 'right') {
        return 'img-title-right';
      } else {
        return 'img-title-center';
      }
    },
  },
};
</script>
